/**
 * The "this campaign cannot send yet" banner of the portal rollout screens
 * (tracker item 81): one line per blocker (portal off, notifications off,
 * welcome message off, no verified sender) with the page that fixes it.
 * Those pages are edited by admins; an office manager is told to ask one.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { blockerFix, blockerLabel } from './portalRolloutUi';

export interface BlockerLike {
  code: string;
  message?: string | null;
}

export function RolloutBlockers({ blockers, isAdmin, heading = 'Invitations cannot go out yet' }: { blockers: BlockerLike[]; isAdmin: boolean; heading?: string }) {
  if (blockers.length === 0) return null;
  return (
    <div role="alert" className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900" data-testid="rollout-blockers">
      <p className="font-semibold">{heading}</p>
      <ul className="mt-2 list-disc space-y-1 pl-5">
        {blockers.map((blocker) => {
          const fix = blockerFix(blocker.code);
          return (
            <li key={blocker.code} data-blocker={blocker.code}>
              {blockerLabel(blocker.code, blocker.message)}{' '}
              {fix && (isAdmin
                ? <>Fix it in <Link to={fix.to} className="font-semibold underline">{fix.label}</Link>.</>
                : <>Ask an admin to fix it in {fix.label}.</>)}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
